import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from '../../../services/analytics.service';
import { IndicadoresFinanceiros } from '../../../models/analytics.model';
import { CombinedIndicatorCardComponent } from '../indicadores-financeiros.component/combined-indicator-card.component';
import { ToastrService } from 'ngx-toastr';
import { DateUtilService } from '../../../services/dateUtil.service';

interface IndicadoresState {
  orcamentos:     { volume: number; valor: number };
  vendas:         { volume: number; valor: number };
  contasPagas:    { volume: number; valor: number };
  contasPendentes:{ volume: number; valor: number };
}

@Component({
  selector: 'app-indicadores-do-mes',
  standalone: true,
  imports: [CommonModule, CombinedIndicatorCardComponent],
  templateUrl: './indicadores-do-mes.component.html',
  styleUrl: './indicadores-do-mes.component.css'
})
export class IndicadoresDoMesComponent implements OnInit {
  isLoading   = signal(true);
  hasError    = signal(false);
  indicadores = signal<IndicadoresState | null>(null);
  periodoLabel = '';

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private dateUtilService: DateUtilService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    const hoje         = this.dateUtilService.dataHoje;
    const primeiroDia  = `${hoje.substring(0, 7)}-01`;
    this.periodoLabel  = `${primeiroDia} a ${hoje}`;
    this.isLoading.set(true);
    this.hasError.set(false);

    this.analyticsService.getIndicadoresFinanceiros(primeiroDia, hoje).subscribe({
      next: data => {
        this.indicadores.set(this.buildState(data));
        this.isLoading.set(false);
      },
      error: () => {
        this.toastr.error('Não foi possível carregar os indicadores do mês.');
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    });
  }

  private buildState(data: IndicadoresFinanceiros): IndicadoresState {
    return {
      orcamentos:      { volume: data.ORCAMENTOS.total       || 0, valor: data.ORCAMENTOS.valorTotal       || 0 },
      vendas:          { volume: data.VENDAS.total            || 0, valor: data.VENDAS.valorTotal            || 0 },
      contasPagas:     { volume: data.CONTAS_PAGAS.total      || 0, valor: data.CONTAS_PAGAS.valorTotal      || 0 },
      contasPendentes: { volume: data.CONTAS_PENDENTES.total   || 0, valor: data.CONTAS_PENDENTES.valorTotal  || 0 }
    };
  }
}
